/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  buildSrc.ts
 */

import { ImageCdnParams } from './ImageCdnParams'
import { toImageCdnUrl } from './toImageCdnUrl'

export const buildSrc = (src: string, params?: ImageCdnParams) => {
  if (!src) {
    return src
  }

  const url = toImageCdnUrl(src, params)

  return url ? url.toString() : src
}
